var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text-smaller mt-1"
  }, [_vm._v(" Please refer to "), _c("a", {
    on: {
      click: function click($event) {
        return _vm.openToS("#storage");
      }
    }
  }, [_vm._v("article 8 of the terms of sales")]), _vm._v(" for more details. ")]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };